import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseDtoSearchService, IBaseDto } from './base-dto.service';
import { AccountClient, SearchAccountsBasicDataParameters } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ReportingAccountSearchService extends BaseDtoSearchService {
    constructor(private readonly client: AccountClient) {
        super();
    }

    async search(filterText: string): Promise<IBaseDto[]> {
        return await lastValueFrom(
            this.client.accountSearchBasicData({ filterText, isActive: true } as SearchAccountsBasicDataParameters)
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    override getById(id: number): Promise<IBaseDto> {
        throw new Error('Method not implemented.');
    }

    async getByIds(accountIds: number[]): Promise<IBaseDto[]> {
        return await lastValueFrom(
            this.client.accountSearchBasicData({
                accountIds
            } as SearchAccountsBasicDataParameters)
        );
    }
}
